import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import useHomeStore from "./ZustandStore/useHomeStore";
import useCartStore from "./ZustandStore/useCartStore";
import Notification from "../helper/Notification";

const CartSection = () => {
  const {
    cartArray,
    handleRemoveAllFromCart,
    isCheckedAll,
    showModal,
    charges,
    handleCloseModal,
    handleShowModal,
    fetchCartItems,
    handleRemoveFromCart,
    handleIsCheckedDel,
    decrementQuantity,
    incrementQuantity,
    handleIsCheckedAll,
    handleCheckboxChange,
    fetchCartDetails,
    deliveryMessage,
  } = useCartStore();

  const { fetchCountProduct } = useHomeStore();

  const navigate = useNavigate();

  useEffect(() => {
    const initializeCart = async () => {
      try {
        // Fetch cart items first
        const fetchedItems = await fetchCartItems();

        const filteredItems = fetchedItems.map(({ id, isChecked }) => ({
          id,
          checked: isChecked, // Rename isChecked to checked
        }));

        if (filteredItems.length > 0) {
          await fetchCartDetails(filteredItems); // Pass filteredItems
        }
      } catch (error) {
        console.error("Error initializing cart:", error);
      }
    };

    initializeCart();
  }, [fetchCartItems, fetchCartDetails]);

  // Empty dependency ensures this runs only on mount

  const [showNotification, setShowNotification] = useState(false);

  const totalPrice = 0;
  return (
    <section className="cart py-10 position-relative">
      <Notification
        show={showNotification}
        type="warning"
        title="Select Items to Checkout"
        message="Please select at least one item from your cart to proceed to checkout."
        onClose={() => setShowNotification(false)}
      />

      {/* my pop up model */}
      {showModal && (
        <div>
          <div
            className="modal-overlay flex-center position-fixed top-0 w-100 h-100 z-2"
            onClick={handleCloseModal}
            style={{
              backdropFilter: "blur(10px)",
              WebkitBackdropFilter: "blur(10px)",
            }}
          ></div>
          <div
            className="modal-content p-20 bg-white shadow-lg position-fixed top-50 start-50 translate-middle z-3"
            style={{ maxWidth: "20rem" }}
          >
            <p className="text-black text-xl">Remove from cart</p>
            <p className="text-muted text-xs">
              Are you sure you want to delete these products?
            </p>
            <div className="modal-actions d-flex justify-content-end mt-26 gap-24">
              <button
                className="btn-cancel text-muted"
                onClick={handleCloseModal}
              >
                CANCEL
              </button>
              <button
                className="btn-confirm bg-main text-main"
                onClick={async () => {
                  await handleIsCheckedDel();
                  await handleRemoveAllFromCart();
                  fetchCountProduct();
                }}
              >
                REMOVE
              </button>
            </div>
          </div>
        </div>
      )}

      {/* my content */}
      <div className="container container-lg px-lg-5">
        <div className="row gy-4">
          <div
            className="col-xl-9 col-lg-8 py-10 px-24"
            style={{
              borderRight: "0.1px solid var(--gray-100)",
            }}
          >
            <div className="flex-between bg-white mb-10 p-10 ">
              <div className="flex-align gap-10">
                <input
                  type="checkbox"
                  className="form-check-input custom-checkbox cursor-pointer "
                  checked={isCheckedAll}
                  onChange={handleIsCheckedAll}
                />
                <p className="mt-4 cursor-pointer" onClick={handleIsCheckedAll}>
                  SELECT ALL
                </p>
                <span className="mt-4">
                  {cartArray.length === 0
                    ? "(Please add product first)"
                    : cartArray.length === 1
                    ? `(${cartArray.length} ITEMS)`
                    : `(${cartArray.length} ITEMS)`}
                </span>
              </div>
              <div
                className="cursor-pointer"
                onClick={() => {
                  handleShowModal();
                }}
              >
                <i className="bi bi-trash text-muted cursor-pointer text-lg "></i>
                DELETE
              </div>
            </div>
            <div className="cart-table">
              {cartArray.length === 0 ? (
                <div className="empty-cart text-center">
                  <h4>Your cart is empty!</h4>
                </div>
              ) : (
                <div className="overflow-x-auto scroll-sm-horizontal">
                  <table className="table bg-color-three border-top-0 border-right-0 border-left-0">
                    <tbody>
                      {cartArray.map((item) => (
                        <tr key={item.id}>
                          <td className="align-middle text-center ">
                            <div className="quantity-control d-flex align-items-start">
                              <input
                                type="checkbox"
                                checked={item.isChecked}
                                onChange={() => handleCheckboxChange(item.id)}
                                className="form-check-input custom-checkbox cursor-pointer"
                              />
                            </div>
                          </td>
                          <td className="align-middle text-center">
                            <div className="table-product d-flex align-items-center gap-24">
                              <Link
                                to={`/product/${item.slug}`}
                                className="table-product__thumb rounded-8 flex-center"
                              >
                                {/* Smaller image with adjusted size */}
                                <img
                                  src={item.productImg}
                                  alt={item.productName}
                                />
                              </Link>
                            </div>
                          </td>
                          <td className="align-middle text-center">
                            <div className="table-product__content text-start">
                              <h6
                                className="title text-lg fw-semibold mb-8"
                                style={{ minWidth: "3rem" }}
                              >
                                <Link
                                  to={`/product/${item.slug}`}
                                  className="link text-line-2"
                                  tabIndex={0}
                                >
                                  {item.productName}
                                </Link>
                              </h6>
                              <h6 className="title text-sm fw-semibold mb-8 text-muted d-none d-md-block">
                                <Link
                                  to={`/product/${item.slug}`}
                                  className="link text-line-2"
                                  tabIndex={0}
                                >
                                  {item.description}
                                </Link>
                              </h6>
                            </div>
                          </td>
                          <td
                            className="align-middle"
                            style={{
                              minWidth: "5rem",
                            }}
                          >
                            <span className="text-md  text-main h6 mb-0 ">
                              Rs. {item.productPrice}
                            </span>

                            <div className="text-decoration-line-through text-xs mb-0 fw-semibold text-muted">
                              Rs. {item.selling}
                            </div>
                            <div className="d-flex gap-16 mt-2">
                              <i
                                className="bi bi-heart text-muted cursor-pointer text-lg"

                                // onClick={() => handleFavorite(item.id)}
                              ></i>
                              <i
                                className="bi bi-trash text-muted cursor-pointer text-lg"
                                onClick={async () => {
                                  await handleRemoveFromCart(item.id);
                                  fetchCountProduct();
                                }}
                              ></i>
                            </div>
                          </td>
                          <td className="align-middle text-center">
                            <div className="quantity-control d-flex align-items-center justify-content-end gap-12">
                              <button
                                className="w-32 h-32 btn-outline-secondary bg-color-three text-muted "
                                onClick={() => decrementQuantity(item.id)}
                              >
                                -
                              </button>
                              <span className="text-nowrap">
                                {item.quantity}
                              </span>
                              <button
                                className="w-32 h-32 btn-outline-secondary bg-color-three text-muted "
                                onClick={() => incrementQuantity(item.id)}
                              >
                                +
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-3 col-lg-4 h-100 position-sticky top-0 bg-white">
            <div className="cart-sidebar  py-20 px-10">
              {/* <p className="text-lg text-muted mb-10">Location</p> */}

              {deliveryMessage && (
                <div className="d-flex align-items-center gap-10">
                  <span
                    className={`p-10 ${
                      deliveryMessage ===
                      "Congratulations! You're eligible for free delivery on this order. Enjoy your shopping!"
                        ? "bg-success text-white"
                        : "bg-warning text-white"
                    }`}
                  >
                    {deliveryMessage}
                  </span>
                </div>
              )}

              {/* divider */}
              <span className="mt-32 text-gray-900 border-top border-gray-100 d-block" />
              <div className="mt-32 p-0">
                <div className="mb-32 flex-between gap-8">
                  <span className="text-gray-900 text-xl font-heading-two">
                    Order Summary
                  </span>
                </div>
                {/** Dynamically render charges */}
                {Object.entries(charges).map(([title, value]) => {
                  if (title === "Total") return null; // Skip "Total" here; render separately if needed
                  return (
                    <div className="mb-32 flex-between gap-8" key={title}>
                      <span className="text-muted font-heading-two">
                        {title}
                      </span>
                      <span className="text-gray-900">
                        Rs. {value?.toFixed(2) || 0.0}
                      </span>
                    </div>
                  );
                })}
                <div className="mb-0 d-flex justify-content-center gap-3 align-items-center">
                  <input
                    type="text"
                    className="form-control w-100 text-sm h-48 text-xs text-md-sm"
                    placeholder="Enter Voucher Code"
                  />
                  <button
                    className="btn text-nowrap text-sm h-48 text-xs text-md-sm"
                    style={{ background: "#194F7D" }}
                  >
                    Apply
                  </button>
                </div>
                <div className="mt-24">
                  <div className="flex-between gap-8">
                    <span className="text-gray-900 text-xl">Total</span>
                    <span className="text-main">
                      Rs.{" "}
                      {charges.Total?.toFixed(2) || (totalPrice + 0).toFixed(2)}
                    </span>
                  </div>
                </div>
                <button
                  className="btn btn-main mt-40 py-18 w-100"
                  onClick={(e) => {
                    e.preventDefault();

                    const selectedItemsCount = cartArray.filter(
                      (item) => item.isChecked
                    ).length;

                    if (selectedItemsCount === 0) {
                      setShowNotification(true);
                      console.log(
                        "No items selected. Cannot proceed to checkout."
                      );
                    } else {
                      setShowNotification(false);
                      console.log("Proceeding to checkout!");
                      navigate("/checkout");
                    }
                  }}
                >
                  Proceed to checkout (
                  {cartArray.filter((item) => item.isChecked).length})
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CartSection;
